/* js/geo-prompt.js — ГЕО-окно первого визита (Plan site-changes-backlog блок 1.4).
 *
 * Поведение (всё клиентски, без inline-обработчиков — CSP strict-dynamic):
 *   • На загрузке: есть cookie bd_city → ВЫЙТИ (окно не показывать). Критично.
 *   • Нет cookie → fetch('/api/geo-detect.php') (same-origin). Ответ:
 *       { ok: true, city: '<slug>', cached?: true, fallback?: true }
 *     ⚠️ endpoint отдаёт ТОЛЬКО slug (не имя/in_our_cities). Имя города берём
 *     из ссылок модалки [data-city-pick][data-city-name] (если есть), иначе
 *     из встроенной карты SLUG_NAMES.
 *   • Консервативно: гео = krasnodar / fallback:true / неизвестный slug →
 *     окно НЕ показываем (cookie не насилуем). Показываем только когда гео —
 *     валидный наш город, ОТЛИЧНЫЙ от дефолта krasnodar.
 *   • Показ: подставить имя в [data-geo-city] + КЛИЕНТСКИ в шапку
 *     [data-bd-city-name] (+ атрибут [data-bd-city]); снять hidden;
 *     запустить 30с-таймер + анимировать прогресс-бар.
 *   • Бездействие 30с ИЛИ клик ✕ → setCookie('bd_city', гео-slug, 180д,
 *     Path=/, SameSite=Lax, Secure) — остаёмся в гео-городе; скрыть окно.
 *   • Клик «Выбрать другой город» ([data-city-modal-open]) — подхватит
 *     city-modal.js (откроет модалку); гео-окно прячем (БЕЗ записи cookie —
 *     cookie запишет city-modal.js по выбору пользователя).
 *   • fetch упал → тихо ничего не делаем (fail-soft).
 *
 * ⛔ АНТИ-КЛОАКИНГ: всё клиентски. Сервер первым рендером всегда krasnodar.
 * URL / canonical / мета НЕ трогаем. /api/geo-detect.php лишь информирует JS.
 *
 * ⚠️ Поведение cookie при перезагрузке во время показа: cookie пишется ТОЛЬКО
 * по завершению таймера / ✕ / выбору. До этого cookie нет → перезагрузка во
 * время показа покажет окно снова (приемлемо — окно идемпотентно).
 *
 * ES5-совместимо (var/function), как js/app.js / js/city-modal.js.
 */
(function () {
  'use strict';

  var COOKIE_NAME = 'bd_city';
  var COOKIE_TTL_DAYS = 180;
  var COUNTDOWN_MS = 30000;
  var DEFAULT_CITY = 'krasnodar'; // сервер-дефолт; гео==дефолт → окно не нужно
  var SLUG_RE = /^[a-z]{2,15}$/;

  // Запасная карта slug→имя (если в DOM нет модалки с data-city-name).
  // Зеркало GeoDetectHandler::SUPPORTED_CITIES + CityRegistry visible-набор.

  var promptEl = document.getElementById('geoPrompt');
  if (!promptEl) return;

  var timerId = null;
  // Тест/демо-режим (?geo_test=<slug>): окно форсится с любого IP, БЕЗ записи
  // cookie (чтобы показывалось при каждой перезагрузке). Только для проверки
  // позиции/вида владельцем — не влияет на прод-логику обычных посетителей.
  var testMode = false;

  /** Есть ли уже cookie bd_city. */
  function hasCityCookie() {
    return /(?:^|;\s*)bd_city=/.test(document.cookie || '');
  }

  /** Запись cookie bd_city (валидация slug). */
  function setCityCookie(slug) {
    if (!slug || !SLUG_RE.test(slug)) return;
    var d = new Date();
    d.setTime(d.getTime() + COOKIE_TTL_DAYS * 24 * 60 * 60 * 1000);
    var secure = (location.protocol === 'https:') ? '; Secure' : '';
    document.cookie = COOKIE_NAME + '=' + slug +
      '; expires=' + d.toUTCString() +
      '; path=/; SameSite=Lax' + secure;
  }

  /** Имя города по slug: сначала из ссылок модалки, иначе из встроенной карты. */
  function cityNameFor(slug) {
    return window.BroniPlaces ? window.BroniPlaces.name(slug) : null;
  }

  /** КЛИЕНТСКАЯ подстановка гео-города в шапку (анти-клоакинг — только JS). */
  function applyCityToHeader(slug, name) {
    var nameNodes = document.querySelectorAll('[data-bd-city-name]');
    for (var i = 0; i < nameNodes.length; i++) {
      nameNodes[i].textContent = name;
    }
    var slugNodes = document.querySelectorAll('[data-bd-city]');
    for (var j = 0; j < slugNodes.length; j++) {
      slugNodes[j].setAttribute('data-bd-city', slug);
    }
  }

  /** Скрыть окно + остановить таймер/анимацию (без записи cookie). */
  function hidePrompt() {
    if (timerId) {
      clearTimeout(timerId);
      timerId = null;
    }
    if (waitId) {           // ещё ждали ухода планки cookie — показ отменён
      clearTimeout(waitId);
      waitId = null;
    }
    promptEl.classList.remove('is-open');
    promptEl.setAttribute('hidden', '');
  }

  /** Запустить прогресс-бар: CSS-переход width 100%→0 за COUNTDOWN_MS. */
  function startProgress() {
    var bar = promptEl.querySelector('[data-geo-progress]');
    if (!bar) return;
    // prefers-reduced-motion → без визуального отсчёта (CSS отключает transition).
    bar.style.transitionDuration = (COUNTDOWN_MS / 1000) + 's';
    bar.style.width = '100%';
    // Форсим reflow перед сбросом ширины, чтобы переход реально запустился.
    void bar.offsetWidth;
    bar.style.width = '0%';
  }

  /**
   * site-changes-backlog 1.5: диспатч клиентской подстановки контента главной.
   *
   * ⛔ АНТИ-КЛОАКИНГ: сервер уже отрендерил Топ-ЖК + рекомендации по cookie
   * (бот/первый визит = krasnodar). Здесь — ТОЛЬКО клиентское событие: слушатели
   * на главной (index-recommendations.js / index-city.js) перезагружают Топ-ЖК +
   * рекомендации под гео-город БЕЗ смены URL/canonical. Идемпотентно, fail-soft
   * (нет слушателей / не главная → no-op). CustomEvent — CSP-safe.
   */
  function dispatchCityPreview(slug) {
    if (typeof document.dispatchEvent !== 'function' || typeof CustomEvent !== 'function') {
      return; // древний браузер → серверный рендер остаётся (fail-soft)
    }
    try {
      document.dispatchEvent(new CustomEvent('bd:city-preview', { detail: { city: slug } }));
    } catch (e) {
      /* fail-soft — серверный рендер остаётся */
    }
  }

  /**
   * Подписи окна. ⛔ Ставятся ЗДЕСЬ, а не в шаблоне (задача В-4, 28.08.2026).
   *
   * Сервер отдаёт узлы пустыми: фраза «Ваш регион — …?» лежала в HTML КАЖДОЙ
   * страницы сайта, а Яндекс отрисовывает страницу как браузер и берёт текст из
   * готового DOM — атрибут `hidden` от попадания в сниппет не спасает (замер
   * 23.08: приветствие соседнего виджета подменило description на 1 456 страницах
   * из 1 470). Робот сюда не попадает: окно рисуется только посетителю без cookie
   * `bd_city` и с гео, отличным от дефолта.
   *
   * Текст собирается узлами, а не innerHTML: имя города приходит из ответа
   * endpoint'а, и склейка разметки со строкой из сети — это XSS-поверхность
   * на пустом месте.
   */
  function paintLabels(name) {
    var title = promptEl.querySelector('[data-geo-title]');
    if (title) {
      title.textContent = '';
      title.appendChild(document.createTextNode('Ваш регион — '));
      var city = document.createElement('span');
      city.className = 'geo-prompt__city';
      city.setAttribute('data-geo-city', '');
      city.textContent = name;
      title.appendChild(city);
      title.appendChild(document.createTextNode('?'));
    }
    var hint = promptEl.querySelector('[data-geo-hint]');
    if (hint) hint.textContent = 'Не тот? Выберите другой город.';
    var choose = promptEl.querySelector('[data-geo-choose]');
    if (choose && choose.textContent === '') choose.textContent = 'Выбрать другой город';
  }

  /**
   * ⛔ ОКНО НЕ ВСПЛЫВАЕТ, ПОКА НА ЭКРАНЕ ПЛАНКА СОГЛАСИЯ НА COOKIE
   * (план yandex-mobile, блок 1.2, 18.09.2026).
   *
   * Замер стенда 375×667, первый заход из Москвы: шапка 9 % + это окно 18,7 % +
   * планка cookie 5,7 % + кружки ≈ 3 % — под плавающими панелями 36,6 % первого
   * экрана. Мобильный робот Яндекса приходит без cookie, то есть ровно в этом
   * состоянии, а справка Яндекса просит держать контент видимым на экране телефона.
   * Два всплывающих окна разом — лишнее: сначала человек отвечает на cookie,
   * потом (сразу после «Принять») видит вопрос о регионе.
   *
   * Откладывается ТОЛЬКО показ карточки. Подстановка города в шапку и контент
   * главной (applyCityToHeader, dispatchCityPreview) идут сразу, как и раньше.
   * 30-секундный отсчёт стартует с момента показа, а не с загрузки — иначе окно
   * успевало бы закрыться, так и не появившись.
   *
   * Планку cookie код согласия удаляет из разметки после выбора, поэтому здесь
   * достаточно спрашивать «есть ли узел». Опрос раз в BANNER_POLL_MS, а не
   * наблюдатель за всем документом: страницы каталога постоянно меняют DOM,
   * и наблюдатель будился бы от каждой карточки.
   */
  var BANNER_POLL_MS = 800;
  var waitId = null;

  function consentBannerShown() {
    return !!document.getElementById('cookie-consent-banner');
  }

  /** Сама карточка: снять hidden, запустить прогресс и 30-секундный таймер. */
  function revealPrompt(slug) {
    waitId = null;
    promptEl.removeAttribute('hidden');
    promptEl.classList.add('is-open');
    startProgress();

    // Бездействие COUNTDOWN_MS → принять гео (записать cookie) + скрыть.
    // В testMode cookie НЕ пишем — окно показывается при каждой перезагрузке.
    timerId = setTimeout(function () {
      if (!testMode) setCityCookie(slug);
      hidePrompt();
    }, COUNTDOWN_MS);
  }

  /**
   * Робот (поисковый и отрисовывающий) окна не видит — так же, как планку cookie.
   * ⛔ Список роботов ОДИН — в public/js/cookie-consent.js (window.CookieConsent.isCrawler):
   *    второй список с тем же смыслом разошёлся бы с первым. Замер 19.09.2026: как только
   *    планку убрали у YandexMobileBot, окно региона досталось ему сразу — 40 % экрана
   *    и H1 закрыт целиком на 320. Этот код обязан закрыть ровно такой случай.
   * Пока cookie-consent.js не загружен — ждём его (он подключён ниже, в подвале), но не
   * дольше CRAWLER_WAIT_POLLS опросов: без него считаем посетителя человеком.
   */
  var CRAWLER_WAIT_POLLS = 10;
  var crawlerPolls = 0;
  function crawlerVerdict() {
    var cc = window.CookieConsent;
    if (cc && typeof cc.isCrawler === 'function') {
      var ua = (typeof navigator !== 'undefined' && navigator && navigator.userAgent) ? String(navigator.userAgent) : '';
      return cc.isCrawler(ua) ? 'bot' : 'human';
    }
    return crawlerPolls++ < CRAWLER_WAIT_POLLS ? 'wait' : 'human';
  }

  /** Показать, как только планка cookie уйдёт (сразу — если её нет). */
  function revealWhenFree(slug) {
    var who = crawlerVerdict();
    if (who === 'bot') { waitId = null; return; }
    if (who === 'wait') {
      waitId = setTimeout(function () { revealWhenFree(slug); }, BANNER_POLL_MS);
      return;
    }
    // Пока ждали, город могли выбрать (модалка без перезагрузки) — выбор человека
    // главнее подсказки: окно не показываем, иначе отсчёт перезаписал бы bd_city.
    if (hasCityCookie()) { waitId = null; return; }
    if (!consentBannerShown()) {
      revealPrompt(slug);
      return;
    }
    waitId = setTimeout(function () { revealWhenFree(slug); }, BANNER_POLL_MS);
  }

  /** Показать окно для гео-города (slug + name валидны). */
  function showPrompt(slug, name) {
    paintLabels(name);
    var citySpan = promptEl.querySelector('[data-geo-city]');
    if (citySpan) citySpan.textContent = name;

    applyCityToHeader(slug, name);
    // Клиентская подстановка контента главной под гео-город (анти-клоакинг).
    dispatchCityPreview(slug);

    // Запоминаем гео-slug на элементе для обработчиков (✕).
    promptEl.setAttribute('data-geo-slug', slug);

    // Демо-режим (?geo_test=) показывает сразу: он для проверки вида окна.
    if (testMode) revealPrompt(slug);
    else revealWhenFree(slug);
  }

  /** Решение «показывать ли окно» по ответу endpoint'а. */
  function decide(data) {
    if (!data || data.ok !== true) return;
    var slug = data.city;
    if (!slug || !SLUG_RE.test(slug)) return;       // невалидный slug → тихо
    if (data.fallback === true) return;             // endpoint не уверен → не показываем
    if (slug === DEFAULT_CITY) return;              // гео == сервер-дефолт → окно не нужно
    var name = cityNameFor(slug);
    if (!name) return;                              // нет имени (не наш город) → тихо
    showPrompt(slug, name);
  }

  // ── Делегирование кликов (CSP: addEventListener, без inline onclick) ──
  // ✕ → принять гео (cookie) + скрыть. «Выбрать другой» — НЕ пишем cookie
  // (city-modal.js запишет по выбору), просто прячем гео-окно.
  promptEl.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    if (t.closest('[data-geo-dismiss]')) {
      e.preventDefault();
      if (!testMode) setCityCookie(promptEl.getAttribute('data-geo-slug'));
      hidePrompt();
      return;
    }

    if (t.closest('[data-city-modal-open]')) {
      // НЕ preventDefault — пусть city-modal.js откроет модалку штатно.
      hidePrompt();
    }
  });

  /** Тест/демо-slug из URL (?geo_test=<slug>). null если нет/невалиден. */
  function getTestCity() {
    var m = (location.search || '').match(/[?&]geo_test=([a-z]{2,15})/i);
    return m ? m[1].toLowerCase() : null;
  }

  var GEO_CACHE_KEY = 'bd_geo_detect';

  /** Ответ гео из памяти вкладки: только валидный ответ сервера, иначе null. */
  function readGeoCache() {
    try {
      var raw = window.sessionStorage && window.sessionStorage.getItem(GEO_CACHE_KEY);
      if (!raw) return null;
      var d = JSON.parse(raw);
      return d && d.ok === true && typeof d.city === 'string' ? d : null;
    } catch (e) {
      return null;
    }
  }

  /** Запомнить ответ гео на время вкладки (только ok-ответ; ошибки не кэшируем). */
  function writeGeoCache(data) {
    if (!data || data.ok !== true || typeof data.city !== 'string') return;
    try {
      if (window.sessionStorage) {
        window.sessionStorage.setItem(GEO_CACHE_KEY, JSON.stringify({ ok: true, city: data.city, fallback: data.fallback === true }));
      }
    } catch (e) { /* приватный режим / квота — без кэша */ }
  }

  /** Запрос гео + решение. fail-soft. */
  function init() {
    // Тест/демо-режим: ?geo_test=<slug> форсит показ с любого IP, в обход
    // cookie + гео-fetch (только если slug — наш валидный город).
    var testSlug = getTestCity();
    if (testSlug && SLUG_RE.test(testSlug)) {
      var testName = cityNameFor(testSlug);
      if (testName) {
        testMode = true;
        showPrompt(testSlug, testName);
      }
      return;
    }

    // City-лендинг (catalog/novostrojki/jk): индикатор в шапке уже = город страницы
    // (server-side, из URL). Не всплываем и НЕ перетираем индикатор геолокацией —
    // юзер выразил выбор города через URL. (?geo_test= выше это обходит для проверки.)
    if (promptEl.getAttribute('data-page-city')) return;

    if (hasCityCookie()) return; // cookie есть → окно НЕ показываем (критично)

    if (typeof fetch !== 'function') return; // нет fetch (древний браузер) → тихо

    // ⛔ Ответ гео — в память вкладки (yandex-mobile 1.2, P2 верификатора). Пока человек
    //    не ответил на планку cookie, окно ждёт, bd_city не пишется — и без кэша КАЖДАЯ
    //    загрузка страницы снова звала бы /api/geo-detect.php. sessionStorage живёт до
    //    закрытия вкладки; недоступен (приватный режим) — просто спрашиваем сервер.
    var cached = readGeoCache();
    if (cached) { decide(cached); return; }

    fetch('/api/geo-detect.php', { credentials: 'same-origin' })
      .then(function (r) { return r && r.ok ? r.json() : null; })
      .then(function (data) { writeGeoCache(data); decide(data); })
      .catch(function () { /* fail-soft — окно не показываем */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Экспорт для тестов.
  window.geoPrompt = {
    init: init,
    decide: decide,
    show: showPrompt,
    hide: hidePrompt,
    setCookie: setCityCookie,
    hasCookie: hasCityCookie,
    cityNameFor: cityNameFor,
    dispatchCityPreview: dispatchCityPreview,
    getTestCity: getTestCity
  };
})();
